import { Routes } from '@angular/router';
import { Paths } from './enums/route-paths.enum';
import { UserPanelComponent } from './component/user-panel/user-panel.component';
import { AdminPanelLayoutComponent } from './layout/admin-panel-layout/admin-panel-layout.component';

export const routes: Routes = [
    {
        path: Paths.admin,
        component: AdminPanelLayoutComponent,
        loadChildren: () =>
            import('./component/admin-panel/admin-panel.module').then(
                (m) => m.AdminPanelModule
            ),
    },
    {
        path: '',
        component: UserPanelComponent,
        loadChildren: () =>
            import('./component/user-panel/user-panel.module').then(
                (m) => m.UserPanelModule
            )
    }
];
